import React from "react";
import Image from "react-bootstrap/Image";
import Modal from "react-modal";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    transform: "translate(-50%, -50%)",
    position: "relative",
    padding: "0px",
  },
};

export const ReservationTimeModel = ({
  onOpenModal,
  open,
  onCloseModal,
  headerText,
  timeOneClick,
  timeTwoClick,
  timeThreeClick,
  timeFourClick,
  timeFiveClick,
  timeSixClick,
  timeTextOne,
  timeTextTwo,
  timeTextThree,
  timeTextFour,
  timeTextFive,
  timeTextSix,
  displayButton,
  displayButtonTwo,
  displayButtonThree,
  afterOpenModal,
}) => {
  return (
    <React.Fragment>
      <Image
        src={require("../../../assets/images/ActionImages/down-chevron.svg")}
        alt="Dropdown"
        title="Dropdown"
        fluid
        className="table-turn-around-dropdown-Image"
        onClick={onOpenModal}
      />
      <Modal
        isOpen={open}
        onAfterOpen={afterOpenModal}
        onRequestClose={onCloseModal}
        style={customStyles}
        className="reservation-vendor-model-popup"
        contentLabel="Example Modal"
        ariaHideApp={false}
      >
        <div>
          <div className="reservation-vendor-model-popup-header">
            <Image
              src={require("../../../assets/images/ActionImages/backbuttonnew.png")}
              alt="back button"
              title="Back Button"
              fluid
              onClick={onCloseModal}
            />
            <h4>{headerText}</h4>
          </div>
          <hr />
          <div className="reservation-vendor-model-popup-bodybox">
            <ul
              type="none"
              className="reservation-vendor-model-popup-bodybox-ul"
            >
              <li onClick={timeOneClick}>{timeTextOne}</li>
              <li onClick={timeTwoClick}>{timeTextTwo}</li>
              <li onClick={timeThreeClick}>{timeTextThree}</li>
              {displayButton === true ? null : (
                <li onClick={timeFourClick}>{timeTextFour}</li>
              )}
              {displayButtonTwo === true ? null : (
                <li onClick={timeFiveClick}>{timeTextFive}</li>
              )}
              {displayButtonThree === true ? (
                <li onClick={timeSixClick}>{timeTextSix}</li>
              ) : null}
            </ul>
          </div>
        </div>
      </Modal>
    </React.Fragment>
  );
};
